var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46447 6.46447C5 7.92893 5 10.286 5 15C5 19.714 5 22.0711 6.46447 23.5355C7.92893 25 10.286 25 15 25C19.714 25 22.0711 25 23.5355 23.5355C25 22.0711 25 19.714 25 15C25 10.286 25 7.92893 23.5355 6.46447C22.0711 5 19.714 5 15 5C10.286 5 7.92893 5 6.46447 6.46447ZM16.75 13C16.75 13.4142 17.0858 13.75 17.5 13.75H18.1893L16.1768 15.7626C16.0791 15.8602 15.9209 15.8602 15.8232 15.7626L14.2374 14.1768C13.554 13.4934 12.446 13.4934 11.7626 14.1768L9.46967 16.4697C9.17678 16.7626 9.17678 17.2374 9.46967 17.5303C9.76256 17.8232 10.2374 17.8232 10.5303 17.5303L12.8232 15.2374C12.9209 15.1398 13.0791 15.1398 13.1768 15.2374L14.7626 16.8232C15.446 17.5066 16.554 17.5066 17.2374 16.8232L19.25 14.8107V15.5C19.25 15.9142 19.5858 16.25 20 16.25C20.4142 16.25 20.75 15.9142 20.75 15.5V13C20.75 12.5858 20.4142 12.25 20 12.25H17.5C17.0858 12.25 16.75 12.5858 16.75 13Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerIcon);
export default __webpack_public_path__ + "static/media/partner_icon.a577bb7ec1ed2448578a22d898bbbaba.svg";
export { ForwardRef as ReactComponent };